import React, { useContext } from "react";

import { Grid, Grow } from "@material-ui/core";
import TextField from "../../../../components/basics/TextFieldErp";
import Card from "../../../../components/cards/Card";

import { Text } from "../styles/Emissao";
import { PainelNfeContext } from "../contexts/PainelNfeContext";

const TabCCNova = ({ ...props }) => {
  const { ccDescription, setCcDescription, ccError } =
    useContext(PainelNfeContext);
  return (
    <Grow in={true}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Card full line="left">
            <Text variant="body1" gutterBottom>
              A Carta de Correção é disciplina pela § 1º-A do art. 7º do
              Convênio S/N e 15 de dezembro de 1970 e pode ser utilizada para
              regularização de erro ocorrido na emissão de documento fiscal,
              desde que o erro não esteja relacionado com:
            </Text>
            <Text gutterBottom>
              I - As variáveis que determinam o valor do imposto tais como: base
              de cálculo, alíquota, diferença de preço, quantidade, valor da
              operação ou da prestação;
            </Text>
            <Text gutterBottom>
              II - A correção de dados cadastrais que implique mudança do
              remetente ou do destinatário; III - a data de emissão ou de saída.
            </Text>
          </Card>
        </Grid>
        <Grid item xs={12}>
          <TextField
            value={ccDescription}
            setValue={setCcDescription}
            label="Descrição"
            multiline
            rows={5}
            variant="filled"
            error={ccError.ccDescription ? true : false}
            helperText={ccError.ccDescription || ""}
          />
        </Grid>
      </Grid>
    </Grow>
  );
};

export default TabCCNova;
